<template>
    <div class="nav_box" v-if="!isLoginPagehandle">
        <nav>
            <div class="logo_top_box">
                <img class="logo_top_img" src="@/assets/img/h5-1/logo-icon.png" alt="">
                <!-- <div class="logo_p_box">
                    <p class="p1">洛素国际艺术教育</p>
                    <p class="p2">RoSSo ARTS & DESIGN EDUCATION</p>
                </div> -->
            </div>
            <div class="link_box" :class="{ 'link_box_hid': searchflag, 'link_box_show': !searchflag }">
                <router-link to="/vip">VIP服务</router-link>
                <router-link to="/Studyabroad">留学服务</router-link>
                <router-link to="/Seedo">SEEDO</router-link>
                <router-link to="/train">语培课程</router-link>
                <router-link to="/International">国际课程</router-link>
                <router-link to="/Singleitem">单项产品</router-link>
                <router-link to="/supervisor">导师CV库</router-link>
                <router-link to="/Ranking">院校排名</router-link>
                <!-- <router-link to="/poster">案例宝</router-link> -->
                <div class="case-btn" @mouseenter="mouseCourse" @mouseleave="leaveCourse"><span class="case-text">历年案例</span></div>
                <router-link to="/about">洛素优势</router-link>
                <router-link to="/mine">我的</router-link>
            </div>
            <!-- <div class="search_box" :class="{ 'search_box_hid': searchflag, 'search_show': !searchflag }">
                <input type="text" placeholder="搜索" @click="showSearch()">
                <img src="../src/assets/img/h5-1/11.png" alt="">
            </div> -->
        </nav>
    </div>
    <div class="case-box" :class="{'case-show': isShowCase, 'case-hidden': !isShowCase}" @mouseenter="mouseCourse"  @mouseleave="leaveCourse">
        <div class="case-item">
            <div class="item-box">
                <div class="item" v-for="(item, index) in seasonList" :key="index" @click="jumpLink(item.value)" :class="{'current-item': isSelect == item.value}">{{ item.label }}</div>
            </div>
        </div>
        
    </div>
    <div class="search_main" :class="{ 'search_main_show': searchflag, 'search_main_hid': !searchflag }"
        @click="hidSearch">
        <div class="search_main_top" @click="hidSearchStop">
            <div class="really_search_box">
                <el-select v-model="value" ref="input2" :multiple="multiple" filterable remote placeholder="TOP7"
                    :remote-method="remoteMethod" :loading="loading" @change="handleOption">
                    <el-option v-for="item in options" :key="item.value" :label="item.productName" :value="item"
                        collapse-tags />
                </el-select>
                <div class="jiantou" @click="searchandle">
                </div>
                <div>
                </div>
            </div>
        </div>
    </div>

    <router-view />

    <div class="fotter" v-if="!isLoginPagehandle">
        <div class="fotter_box">
            <img src="./assets/img/h5-1/logo-icon.png" alt="">
            <!-- <p class="desc">RoSSo Arts&Design Education</p> -->
            <p class="adress">上海（总部） / 北京 / 广州 / 深圳 / 杭州 / 南京 / 成都 / 武汉 / 西安</p>
        </div>

    </div>

</template>
<script>

import { ref, onMounted, onBeforeUnmount, watch, computed } from 'vue'
import { useRouter } from 'vue-router';
import request from './assets/js/request.js';
import { useStore } from 'vuex';
import setWaterMark from "@/assets/js/watermark.js"
import { skipUrl, getWindowInfo, detectDeviceType } from "@/assets/js/utils.js"
import device from "current-device";

import '@/assets/css/App.css'
export default {
    setup() {
        const isLoginPagehandle = computed(() => store.getters.isLoginPage);
        console.log(isLoginPagehandle, 'isLoginPagehandle')
        const multiple = ref(false)
        const router = useRouter();
        const searchflag = ref(false);
        const searchValue = ref('')
        const input2 = ref(null);
        let screenWidth = ref(document.body.clientWidth)
        // 显示历年按钮
        let isShowCase = ref(false)
        let isSelect = ref(null)
        let seasonList = ref([
            {label: '2026申请季', value: '2026'},
            {label: '2025申请季', value: '2025'}
        ])

        // ************
        const shuaxin = () => {

            router.push('/vip')
            // location.reload(); // 刷新当前页面
        }

        const showSearch = (() => {
            input2.value.focus()
            searchflag.value = !searchflag.value
            // console.log(searchflag.value);
        })
        const hidSearch = (() => {
            // console.log("执行hid");
            searchflag.value = false
        })
        const hidSearchStop = ((event) => {
            event.stopPropagation();
        })



        watch(searchflag, (isOpen) => {
            if (isOpen) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = 'auto';
            }
        });

        onBeforeUnmount(() => {
            watch(() => router.fullPath, (to, from) => {
                console.log('路由发生变化', to, from);
            });
        });

        // 搜索 api

        const list = ref([])
        const options = ref([])
        const value = ref([])
        const loading = ref(false)

        const store = useStore();
            
        // 三端切换
        const switchTerm = () => {
            const params = skipUrl()
            const type = device.type
            const isTouchEnd = 'ontouchend' in document
            if (type == 'mobile') {
                if (window.location.href.includes(params.h5_url)) return
                window.location.href = process.env.VUE_APP_H5_SKIP_URL
            } else if (type == 'tablet') {
                if (window.location.href.includes(params.tab_url)) return
                window.location.href = process.env.VUE_APP_TAB_SKIP_URL
            } else {
                if (!!isTouchEnd) {
                    if (window.location.href.includes(params.tab_url)) return
                    window.location.href = process.env.VUE_APP_TAB_SKIP_URL
                } else {
                    if (window.location.href.includes(params.pc_url)) return
                    window.location.href = process.env.VUE_APP_PC_SKIP_URL
                }
            }
        }
        onMounted(() => {
            setWaterMark()
            switchTerm()
            const ua = navigator.userAgent
            const deviceInfo = detectDeviceType()
            window.addEventListener('resize',function() {
                switchTerm()
            })
            
        })
        // 
        // 提交 搜索
        const searchandle = ((event) => {
            if (searchType.value == 2) {
                router.push({
                    path: `/SingleDetail`,
                    query: {
                        "foreServiceId": searchId.value
                    }
                })
            } else {
                // 大类
                router.push({
                    path: `/vip`,
                    query: {
                        "ForeProdCategoryId": searchId.value,
                    }
                })
            }
            value.value = ''
            showSearch()
        })
        const remoteMethod = (query) => {
            if (query) {
                console.log(query, "query");
                getSearchData(query)
            } else {
                options.value = []
            }
        }
        var searchType = ref()
        var searchId = ref()
        const handleOption = (val) => {
            value.value = val.productName
            searchId.value = val.id
            searchType.value = val.type
            searchandle()
        }
        const getSearchData = (val) => {
            request.get('/api/product/getselectforeproduct', {
                params: {
                    'ProdName': val
                }
            }).then((res) => {
                loading.value = true
                setTimeout(() => {
                    loading.value = false
                    options.value = res.data
                }, 200)

            })
        }

        // 
        const mouseCourse = () => {
            isShowCase.value = true
        }
        // 
        const  leaveCourse = () => {
            isShowCase.value = false
        }

        // 
        const jumpLink = (value) => {
            isSelect.value = value
            isShowCase.value = false
            if (value == 2025) {
                router.push('/poster')
            } else {
                router.push('/poster2026')
            }
            
        }



        router.beforeEach((to, from) => {
            const activeList = ['poster', 'poster2026']
            const pathList = to.path.split('/')[1]
            if (!activeList.includes(pathList)) {
                isSelect.value = null
            }
            searchflag.value = false
        });
        return {
            searchflag,
            searchValue,

            list,
            options,
            value,
            loading,
            multiple,
            searchId,
            input2,
            shuaxin,
            isLoginPagehandle,
            // ****************
            showSearch,
            hidSearch,
            searchandle,
            hidSearchStop,
            remoteMethod,
            handleOption,
            getSearchData,
            mouseCourse,
            isShowCase,
            leaveCourse,
            seasonList,
            jumpLink,
            isSelect
        }
    }
}
</script>

<style  lang="less">
body{
    padding-top: 90px;
    box-sizing: border-box;
}
#app {
    font-family: Microsoft YaHei, Microsoft YaHei, Avenir, Helvetica, Arial, sans-serif;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    // min-height: 100vh; /* 设置最小高度为视口高度 */
    // color: #2c3e50;
    // min-width: 1200px;
}

* {
    padding: 0;
    margin: 0;

}
.nav_box{
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100; /* 确保导航栏在最上层 */
}
// .fotter_box{
//     text-align: center;
// }
</style>
